var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#7F27FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.649 7.87497H4.51125V11.9373C4.50675 12.353 4.67325 12.753 4.9725 13.0466C5.27175 13.3402 5.67956 13.5039 6.10313 13.5H8.64956L8.649 7.87497ZM8.74462 5.74929H9.19012C9.63112 4.98991 10.035 4.47354 10.4147 4.19454C10.8827 3.84972 11.3619 3.84691 11.7377 4.21591C12.0887 4.56016 12.1545 4.99216 11.9233 5.40841C11.8581 5.52429 11.7714 5.63791 11.6629 5.74929H13.2986C13.6806 5.74929 14.0625 6.06316 14.0625 6.4991C14.0625 6.87429 13.7424 7.24947 13.2986 7.24947H9.28575V6.24935H8.649V7.24947H4.70137C4.32 7.24947 3.9375 6.9356 3.9375 6.4991C3.9375 6.12448 4.25756 5.74929 4.70137 5.74929H6.35513C6.25164 5.65287 6.15954 5.54491 6.08063 5.42754C5.80669 5.00904 5.83988 4.56691 6.19706 4.21591C6.57281 3.84691 7.05206 3.85029 7.52062 4.19454C7.89975 4.47354 8.30363 4.99047 8.74519 5.74929H8.74462ZM8.00494 5.74929C7.67869 5.2301 7.38731 4.87741 7.13869 4.6946C6.90862 4.52585 6.78263 4.52472 6.64706 4.65747C6.50813 4.79416 6.49969 4.91116 6.61613 5.08891C6.74888 5.29198 7.02844 5.52091 7.43119 5.74929H8.00494ZM9.92981 5.74929H10.6161C11.0002 5.52879 11.2539 5.30604 11.3642 5.10804C11.4598 4.93704 11.4396 4.8071 11.2877 4.65804C11.1521 4.52473 11.0261 4.52529 10.7966 4.6946C10.5474 4.87741 10.2549 5.2301 9.92981 5.74929ZM9.28575 7.87441H13.4241V11.9373C13.4258 12.1438 13.3859 12.3484 13.3066 12.539C13.2274 12.7297 13.1104 12.9023 12.9628 13.0466C12.661 13.3416 12.2543 13.5047 11.8322 13.5H9.28575V7.87441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGto);
export default __webpack_public_path__ + "static/media/gto.66cf6751b3978f0ffc644f4c94ec4ba8.svg";
export { ForwardRef as ReactComponent };